import { motion } from "framer-motion";

export const easeOut = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay, ease: easeOut }}
        {...rest}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay, ease: easeOut }}
        >
            {children}
        </motion.span>
    </span>
);

export const Eyebrow = ({ children, light = false }) => (
    <p
        className={`text-[11px] font-bold uppercase tracking-[0.28em] ${
            light ? "text-[#FFFFFF]/60" : "text-[#102036]/70"
        }`}
    >
        {children}
    </p>
);
